module.exports = __webpack_public_path__ + "static/media/2.009d297c.jpg";